import React from 'react'
import { Tooltip as TooltipUI } from '@material-ui/core'

export const TooltipBase = ({ title, onOpen, onClose, open, classes, children, ...other }) => (
  <TooltipUI title={title}
    onOpen={onOpen}
    onClose={onClose}
    open={open}
    classes={{ tooltip: classes.tooltip }}
    {...other}
  >
    {children}
  </TooltipUI>
)



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.js